import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography } from '@mui/material';

import * as ApprovalActions from '../../../store/actions/approval.action';
import { getApprovalState } from '../../../store/selector/approval.selector';
import { columns } from './approval-list-column';
import SearchBar from '../../../shared/components/ui/dashboard-layout/search-bar';
import DynamicDataGrid from '../../../shared/components/ui/datagrid/datagrid';

const ApprovalList = () => {
  const dispatch = useDispatch();
  /* eslint-disable camelcase */
  const {
    list: { pages, total, current_page, count, items },
    query,
  } = useSelector(getApprovalState);

  useEffect(() => {
    const q = { ...query, q: '!approved' };

    if (query) dispatch(ApprovalActions.ApprovalFetchApplications(q));
  }, []);

  const SearchAction = (e: string) => {
    const q = { ...query, q: `!approved,${e}` };

    if (query) dispatch(ApprovalActions.ApprovalFetchApplications(q));
  };

  const onPaginationRequest = (page: number) => {
    const q = { ...query, page: page + 1 };
    if (q) dispatch(ApprovalActions.ApprovalFetchApplications(q));
  };

  return (
    <>
      <Typography sx={{ fontSize: '1.75rem', mb: '2rem' }}>List of Applications</Typography>

      <Grid container>
        <Grid item md={4} xs={12}>
          <SearchBar onSearchValueChange={(e: string) => SearchAction(e)} />
        </Grid>
      </Grid>

      <Box
        sx={{
          mt: '2rem',
          background: '#fff',
          height: '70vh',
          width: '100%',
        }}
      >
        {pages ? (
          <DynamicDataGrid
            onPagination={(page: number) => onPaginationRequest(page)}
            columns={columns}
            rows={items}
            config={{
              count: count,
              currentPage: current_page,
              pages: pages,
              total: total,
            }}
          />
        ) : (
          <Box
            sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            No Data Found
          </Box>
        )}
      </Box>
    </>
  );
};

export default ApprovalList;
